import styled from "styled-components";

const BaseCard = styled.div`
  background: #f1f1f1;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  min-height: 200px;
  width: 100%;
`;

export default BaseCard;



// WEBPACK FOOTER //
// ./src/components/carousel/BaseCard.jsx